import gql from 'graphql-tag';
import { AUTHOR_FRAGMENT } from './author.fragment';
import { TAG_FRAGMENT } from './tag.fragment';

export const ACADEMIC_WORK_FRAGMENT = gql`
  fragment AcademicWorkData on Summary {
    id
    externalLink
    originalLanguage
    authors {
      ...AuthorData
    }
    content {
      text
      language
      title
      translator
    }
    tags {
      ...TagData
    }
  }
  ${AUTHOR_FRAGMENT}
  ${TAG_FRAGMENT}
`;
